import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Deals from "@/components/Deals";
import FeaturesBar from "@/components/FeaturesBar";
import Categories from "@/components/Categories";
import Featured from "@/components/Featured";
import ProductPage from "@/components/ProductPage";
import CategoryPage from "@/components/CategoryPage";
import SearchPage from "@/components/SearchPage";
import WishlistPage from "@/components/WishlistPage";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import CheckoutModal from "@/components/CheckoutModal";
import WhatsAppButton from "@/components/WhatsAppButton";
import AdminPage from "@/components/AdminPage";
import AccountPage from "@/components/AccountPage";
import { PaymentSuccess, PaymentCancel } from "@/components/PaymentResult";

function Home() {
  return (
    <>
      <Nav />
      <main>
        <Hero />
        <Deals />
        <Categories />
        <Featured />
        <Contact />
        <FeaturesBar />
      </main>
      <Footer />
      <CartDrawer />
      <CheckoutModal />
    </>
  );
}

function App() {
  useEffect(() => {
    document.title = "Cambroo — Mobile Accessories in Dubai | Cambroo General Trading LLC";
  }, []);

  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <CartProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/product/:productId" element={<ProductPage />} />
                <Route path="/category/:categoryId" element={<CategoryPage />} />
                <Route path="/search" element={<SearchPage />} />
                <Route path="/wishlist" element={<WishlistPage />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/account" element={<AccountPage />} />
              </Routes>
            </BrowserRouter>
            <WhatsAppButton />
            <Toaster
              theme="light"
              position="bottom-center"
              duration={2500}
              toastOptions={{
                style: {
                  background: "#FFFFFF",
                  color: "#404553",
                  border: "1px solid #E5E7EB",
                  borderRadius: 8,
                  boxShadow: "0 8px 24px rgba(64,69,83,0.12)",
                },
              }}
            />
          </CartProvider>
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
